import { WasmLoad } from "@pdfking/compatibility"
import PDFiumModule from "@pdfking/renderer-wasm-pdfium/loader"

import wasm from "./wasm/pdfium.esm.wasm"

export const InitPdfium = () =>
  WasmLoad(wasm).then(wasmBinary => PDFiumModule({ wasmBinary }))
